import angular from 'angular';
import { contractEntering } from 'redevConfig';

const list = (contractEntering && contractEntering.list) || '';
const edit = (contractEntering && contractEntering.edit) || '';

const listPage = list
  ? require(`redevelopment/input/contractEntering/${list.templateName}`)
  : require('./view/list.html');
const listCtrl = list
  ? require(`redevelopment/input/contractEntering/${list.controllerName}`)
  : require('./listCtrl');

const editPage = edit
  ? require(`redevelopment/input/contractEntering/${edit.templateName}`)
  : require('./view/edit.html');
const editCtrl = edit
  ? require(`redevelopment/input/contractEntering/${edit.controllerName}`)
  : require('./editCtrl');

import toolbar from './imageToolbarComponent';
import contractCover from './contractCover';
import contractImage from './contractImage';
import contractInvoice from './contractInvoice';
import invoiceForm from './invoiceForm';
import contractScanCtrl from './ContractScanCtrl';

export default angular
  .module('input.electronImage.contractEntering', [
    toolbar,
    contractCover,
    contractImage,
    contractInvoice,
    invoiceForm,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('input.electronImage.contractEntering', {
        abstract: true,
        url: '/contractEntering',
        template: '<div ui-view=""></div>',
        title: '合同录入',
        default: 'input.electronImage.contractEntering.list',
      });
      $stateProvider.state('input.electronImage.contractEntering.list', {
        url: '/list',
        template: listPage,
        controller: 'contractEnteringListCtrl',
      });
      $stateProvider.state('input.electronImage.contractEntering.edit', {
        url: '/edit/:contractId/:tabIndex/:mode',
        template: editPage,
        controller: 'contractEnteringEditCtrl',
        title: '编辑',
      });
    },
  ])
  .controller('contractEnteringListCtrl', listCtrl.default)
  .controller('contractEnteringEditCtrl', editCtrl.default)
  .controller('contractScanCtrl', contractScanCtrl).name;



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/index.js